module.exports = __webpack_public_path__ + "img/booth-ekb.47b80167.jpg";